export default __webpack_public_path__ + "static/media/Appreciation.543f6615.svg";